import { render, staticRenderFns } from "./rc-info-chip-dropdown.vue?vue&type=template&id=5d4cdb3c&scoped=true&"
import script from "./rc-info-chip-dropdown.vue?vue&type=script&lang=js&"
export * from "./rc-info-chip-dropdown.vue?vue&type=script&lang=js&"
import style0 from "./rc-info-chip-dropdown.vue?vue&type=style&index=0&id=5d4cdb3c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d4cdb3c",
  null
  
)

export default component.exports